class ToastNotification extends HTMLElement {

  constructor() {
    // usage:
    // document.querySelector('toast-notification').notify(notifyMessage, 'success', 3);
    // type = alert, error, success; time in secs
    super();
    this.delay = 3; // fallback
    this.notify = this.handleNotification.bind(this);
  }

  handleNotification(message, type, delay) {
    if (delay === undefined) {
      delay = this.delay
    };

    let notification = document.createElement('div');
    notification.innerHTML = message;
    this.appendChild(notification);
    notification.classList.add(type);

    var tl = new gsap.timeline();
    tl.to(notification, {
      duration: 0.3,
      autoAlpha: 1,
      y: '150%',
      ease: "back.out"
    });

    tl.to(notification, {
      duration: 0.3,
      delay: delay,
      autoAlpha: 0,
      y: 0,
      ease: "back.in"
    });
  }
}

customElements.define('toast-notification', ToastNotification);